import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

function Bergwandern() {
  return (
    <div className="page-bg">
      <header className="header text-center">
        <h1 className="display-4">ESV Bludenz - Sektion Bergwandern</h1>
      </header>

      <main className="container my-5 d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
        <div className="bg-white p-4 rounded shadow-sm text-center" style={{ maxWidth: "600px", width: "100%" }}>
          <p>
            <strong>ESV - Bludenz</strong><br />
            Eisenbahnersportverein Bludenz<br />
            Sektion Bergwandern<br />
          </p>
          <p>
            <strong>Sektionsleiter:</strong><br />
            Gerhard Vonbank <br />
            E-Mail: gerhardvonbank@gmx.at<br />
          </p>

          <img
            src="images/logo_dittes.png"
            alt="Dittes Logo"
            className="img-fluid mx-auto d-block"
            style={{ maxWidth: "300px", margin: "2rem auto" }}
          />

          <Link to="/" className="btn btn-impressum mt-3">
            Zurück zur Sektionsübersicht
          </Link>
        </div>
      </main>

      <footer className="footer text-center">
        © {new Date().getFullYear()} ESV Bludenz – Ein Verein für alle Eisenbahner:innen
      </footer>
    </div>
  );
}

export default Bergwandern;
